import { Card, Text } from "@components/theming";

export default function QueueCountdown({
  msRemaining,
  t,
}: {
  msRemaining: number;
  t: (key: string) => string;
}) {
  const total = Math.floor(msRemaining / 1000);
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;

  const units = [
    ...(days > 0 ? [{ label: t("countdownDays"), value: days }] : []),
    { label: t("countdownHours"), value: hours },
    { label: t("countdownMins"), value: minutes },
    { label: t("countdownSecs"), value: seconds },
  ];

  return (
    <div className="mt-6 flex gap-3">
      {units.map((u) => (
        <Card
          key={u.label}
          sharedClasses="flex-1 text-center"
          shopsiteClasses="rounded-xl bg-gray-50 px-2 py-3"
          variant="classic"
        >
          <Text
            as="p"
            sharedClasses="tabular-nums"
            size="6"
            weight="bold"
            shopsiteClasses="text-2xl font-black text-black sm:text-3xl"
          >
            {u.value.toString().padStart(2, "0")}
          </Text>
          <Text
            as="p"
            size="1"
            weight="medium"
            sharedClasses="mt-0.5 uppercase tracking-wide"
            shopsiteClasses="text-xs font-medium text-gray-500"
            whitelabelClasses="text-[color:var(--gray-11)]"
          >
            {u.label}
          </Text>
        </Card>
      ))}
    </div>
  );
}
